function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.3 3.2C2 3.2 1 4.3 1 5.5v9c0 1.2 1 2.2 2.2 2.2h13.5c1.2 0 2.2-1 2.2-2.2v-9c0-1.2-1-2.2-2.2-2.2H3.3zM4 5c-.6 0-1 .4-1 1v2h2.1c.9 0 1.8.4 2.4 1 1.4 1.4 3.6 1.4 4.9 0 .7-.6 1.6-1 2.6-1h2V6c0-.6-.4-1-1-1H4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgWallet;